module.exports = __webpack_public_path__ + "static/media/uber-rewards-tap-network-logo.b75b46f0.svg";